export default __webpack_public_path__ + "static/media/MissingLocationPlaceholder.118e2627.png";